// src/components/inputs/textArea/customTextArea/index.js
/* eslint-disable react/prop-types */
import React from 'react'

// Wrapper simples para manter padrão do projeto.
// Se você já tiver um estilo global, aplique aqui.
const CustomTextArea = ({ style, ...props }) => (
  <textarea
    {...props}
    style={{
      width: '100%',
      minHeight: 110,
      padding: 12,
      borderRadius: 4, // << mais “quadradinho”
      border: '1px solid #DADADA',
      background: '#FFF',
      resize: 'vertical',
      outline: 'none',
      boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.04)',
      ...style,
    }}
  />
)

export default CustomTextArea
